import { CheckboxAdapter } from 'components/enhanced/form/adapters/CheckboxAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IMovementReason } from '../types';
import { SectionHeader } from 'components/ui/typography';

interface MovementReasonsFormParams {
  movementReason: IMovementReason;
  onSubmit: any;
}

const directions = [
  {
    value: 1,
    display_name: 'IN'
  },
  {
    value: -1,
    display_name: 'OUT'
  }
];

export const MovementReasonsForm = ({ movementReason, onSubmit }: MovementReasonsFormParams) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.reason.sections';

  const [discounted, setDiscounted] = useState(false);
  const [orderIndependent, setOrderIndependent] = useState(false);

  useEffect(() => {
    if (movementReason) {
      setDiscounted(movementReason.discounted);
      setOrderIndependent(movementReason.order_independent);
    }
  }, [movementReason]);

  return (
    <>
      {movementReason && (
        <EnhancedForm onSubmit={onSubmit} edit={!!movementReason.id} columns={3} autoStyleLayout>
          <SectionHeader
            title={t(`${translationPrefix}.base-info.title`)}
            subtitle={t(`${translationPrefix}.base-info.subtitle`)}
            gridSpan
          />
          <IdentityField
            gridSpan={2}
            name="code"
            component={TextFieldAdapter}
            initialValue={movementReason.code}
            label={t('global.code')}
            type="text"
            validate={required}
            tooltip={t(`${translationPrefix}.tooltips.code`)}
          />
          <IdentityField
            name="direction"
            component={AutocompleteAdapter}
            initValue={directions.find((s) => s.display_name === movementReason.direction)}
            defaultValue={directions.find((s) => s.display_name === movementReason.direction).value}
            options={directions}
            optionLabel="display_name"
            optionValue="value"
            label={t('entities.movement.direction')}
            type="text"
            validate={required}
            tooltip={t(`${translationPrefix}.tooltips.direction`)}
          />
          <IdentityField
            gridSpan={3}
            name="description"
            component={TextFieldAdapter}
            initialValue={
              movementReason.description
                ? movementReason.description.split(' - ')[1] || movementReason.description
                : ''
            }
            label={t('global.description')}
            placeholder={t('global.description')}
            type="text"
            validate={required}
            tooltip={t(`${translationPrefix}.tooltips.description`)}
          />
          <SectionHeader
            title={t(`${translationPrefix}.rules.title`)}
            subtitle={t(`${translationPrefix}.rules.subtitle`)}
            gridSpan
          />
          <IdentityField
            name="discounted"
            component={CheckboxAdapter}
            initialValue={movementReason.discounted}
            label={t('entities.movement.discounted')}
            type="checkbox"
            tooltip={t(`${translationPrefix}.tooltips.discounted`)}
          />
          <IdentityField
            name="order_independent"
            component={CheckboxAdapter}
            initialValue={movementReason.order_independent}
            label={t('entities.movement.order_independent')}
            type="checkbox"
            tooltip={t(`${translationPrefix}.tooltips.order_independent`)}
          />
          <IdentityField
            name="ddt"
            component={CheckboxAdapter}
            initialValue={movementReason.ddt}
            label={t('entities.movement.ddt')}
            type="checkbox"
            tooltip={t(`${translationPrefix}.tooltips.ddt`)}
          />
        </EnhancedForm>
      )}
    </>
  );
};

export default MovementReasonsForm;
